/* tss-pro-cart-drawer.js — CACHED COPY of the cart-drawer script (free-shipping bar, priority processing, upsells, confetti)
 * that used to be inline at the end of snippets/cart-drawer.liquid. Moved 2026-10-23 so it can be cached.
 * Its one Liquid value is now window.__tssProCartDrawerCfg.confettiFired, set inline by the snippet just before this file.
 * Loaded as a normal (sync, non-defer) script at the same spot, so execution order/timing is unchanged. */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 50000;
  var PRIORITY_VARIANT_ID = 49466115162411;
  /* Legacy free-gift variant — feature removed. Kept only so we can strip it from
     any cart that still carries it from before the feature was retired. */
  var FREE_GIFT_VARIANT_ID = 51555315613995;
  var PRIORITY_PRODUCT_ID = 9641050046763;
  /* Upsells: TSS in-theme engine (window.TSSRecs from tss-recommendations.js, fed by the
     tss_upsell_rule metaobjects rendered into #tss-cart-rules). Replaced the Rebuy
     data-source 198483 fetch on 2026-10-24. Engine output is mapped into the same
     product shape the old Rebuy renderer used, so renderUpsells/showVariantPopup are
     unchanged. */
  var UPSELL_SLOTS = 14;
  var cachedRebuyProducts = []; /* name kept from the Rebuy era — now engine products in Rebuy shape */
  var _upsellSig = null;        /* cart signature the cached list was built for */
  var _upsellReloadQueued = false;
  var _upsellWaitTries = 0;
  var _upsellWaiting = false;
  var upsellProductMap = {};
  var upsellLoadInFlight = false;
  var _confettiFired = !!(window.__tssProCartDrawerCfg && window.__tssProCartDrawerCfg.confettiFired);
  var _priorityEnsureInFlight = false;
  var _priorityJustAdded = false; /* set when ensurePriorityInCart had to add the line */
  var _currentCart = null;
  var drawerEl = null;

  /* ──────────────────────────────────────────────
     Helpers
  ────────────────────────────────────────────── */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isTSSApp() {
    return /TSSApp\//.test(navigator.userAgent || '');
  }

  function notifyTSSAppCartAdded() {
    try {
      var handlers = window.webkit && window.webkit.messageHandlers;
      var bridge = handlers && handlers.tssApp;
      if (bridge && typeof bridge.postMessage === 'function') {
        bridge.postMessage({ type: 'cart_added' });
      }
    } catch (e) {}
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { _currentCart = cart; return cart; });
  }

  /* ──────────────────────────────────────────────
     Service add-ons (Priority Handling, Order Protection, legacy free gift) are not
     items to the shopper: they never count, and a cart holding only add-ons is empty
     (no checkout; the add-ons are stripped). Keep in step with
     snippets/tss-cart-real-count.liquid.
  ────────────────────────────────────────────── */
  var ORDER_PROTECTION_PRODUCT_ID = 9640963637547;

  function isAddonItem(it) {
    if (!it) return false;
    var vid = it.variant_id || it.id;
    if (vid === PRIORITY_VARIANT_ID || vid === FREE_GIFT_VARIANT_ID) return true;
    if (it.product_id === PRIORITY_PRODUCT_ID || it.product_id === ORDER_PROTECTION_PRODUCT_ID) return true;
    if (it.handle === 'skip-the-line-priority-handling' || it.handle === 'order-protection') return true;
    if (it.vendor === 'Order Protection' || it.product_type === 'Insurance') return true;
    if (it.properties && it.properties._priority_handling) return true;
    return false;
  }

  function realLineCount(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) if (!isAddonItem(cart.items[i])) n++;
    return n;
  }

  function realItemCount(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) if (!isAddonItem(cart.items[i])) n += cart.items[i].quantity || 0;
    return n;
  }

  /* Shared with other theme scripts that write the header count themselves. */
  window.tssCartRealCount = realItemCount;

  /* Only add-ons left (e.g. the last real item was just removed) → remove them, then
     re-render the drawer + header count. Resolves with the (possibly emptied) cart. */
  var _stripInFlight = false;
  function stripOrphanAddons(cart) {
    if (!cart || !cart.items || !cart.items.length || realLineCount(cart) > 0) return Promise.resolve(cart);
    if (_stripInFlight) return Promise.resolve(cart);
    _stripInFlight = true;
    var updates = {};
    cart.items.forEach(function (it) { updates[it.key] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () { return fetchCart(); })
      .then(function (c) { _stripInFlight = false; syncDrawerFromCart(); return c; })
      .catch(function () { _stripInFlight = false; return cart; });
  }

  /* ──────────────────────────────────────────────
     Priority Handling — auto-add to every cart
  ────────────────────────────────────────────── */

  function cartHasPriority(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === PRIORITY_VARIANT_ID ||
          cart.items[i].id === PRIORITY_VARIANT_ID) return true;
    }
    return false;
  }

  function ensurePriorityInCart() {
    if (_priorityEnsureInFlight) return Promise.resolve();
    _priorityEnsureInFlight = true;
    return fetchCart()
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          _priorityEnsureInFlight = false;
          return cart;
        }
        /* Only add-ons in the cart: never add Priority Handling, strip what's there */
        if (realLineCount(cart) === 0) {
          _priorityEnsureInFlight = false;
          return stripOrphanAddons(cart);
        }
        if (cartHasPriority(cart)) {
          _priorityEnsureInFlight = false;
          return cart;
        }
        /* Don't add priority to an empty cart */
        _priorityJustAdded = true;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: PRIORITY_VARIANT_ID,
              quantity: 1,
              properties: { _priority_handling: 'true' }
            }]
          })
        })
        .then(function () { return fetchCart(); })
        .then(function (c) { _priorityEnsureInFlight = false; return c; })
        .catch(function () { _priorityEnsureInFlight = false; });
      });
  }

  function removePriorityFromCart() {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: PRIORITY_VARIANT_ID, quantity: 0 })
    }).then(function () { return fetchCart(); });
  }

  /* ──────────────────────────────────────────────
     Legacy free-gift cleanup — feature removed. Strip the OptiGrit sample pack
     from any cart that still carries it from before the feature was retired.
  ────────────────────────────────────────────── */

  var _freeGiftInFlight = false;

  function cartHasFreeGift(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === FREE_GIFT_VARIANT_ID ||
          cart.items[i].id === FREE_GIFT_VARIANT_ID) return true;
    }
    return false;
  }

  function removeFreeGiftFromCart() {
    if (_freeGiftInFlight) return Promise.resolve();
    _freeGiftInFlight = true;
    /* The gift line carries line-item properties, so it must be removed by its
       line-item key (<variant_id>:<hash>) — /cart/change.js rejects the bare id. */
    return fetchCart().then(function (cart) {
      var gift = ((cart && cart.items) || []).filter(function (it) {
        return (it.variant_id || it.id) === FREE_GIFT_VARIANT_ID;
      })[0];
      if (!gift) { _freeGiftInFlight = false; return cart; }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: gift.key, quantity: 0 })
      }).then(function () { _freeGiftInFlight = false; return fetchCart(); });
    }).catch(function () { _freeGiftInFlight = false; });
  }

  /* Remove the legacy free gift if it's still in the cart. No-op otherwise. */
  function reconcileFreeGift(cart) {
    if (!cart) return Promise.resolve();
    if (cartHasFreeGift(cart)) return removeFreeGiftFromCart();
    return Promise.resolve(cart);
  }

  /* No toggle — priority handling is silent. Kept as a no-op for safety. */
  function togglePriorityBanner() { /* intentionally empty */ }

  /* ──────────────────────────────────────────────
     Shipping bar update (post re-render)
  ────────────────────────────────────────────── */

  function qualifyingTotal(cart) {
    /* Total used for threshold checks — excludes priority handling and the free gift
       itself (so adding the gift doesn't suddenly put the cart over $350 via $0 item). */
    if (!cart || !cart.items) return 0;
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var vid = it.variant_id || it.id;
      if (vid === PRIORITY_VARIANT_ID) continue;
      if (vid === FREE_GIFT_VARIANT_ID) continue;
      total += it.final_line_price || (it.final_price * it.quantity) || 0;
    }
    return total;
  }

  function updateShippingBar(cart) {
    if (!cart) return;
    var drawer = getDrawer();
    if (!drawer) return;
    var msg = drawer.querySelector('#tss-shipping-msg');
    var fill = drawer.querySelector('.tss-shipping-progress__fill');
    var truckIcon = drawer.querySelector('#tss-shipping-icon-truck');

    var qual = qualifyingTotal(cart);
    var remainingShip = Math.max(0, FREE_SHIPPING_THRESHOLD - qual);
    var pct = qual <= 0 ? 0 : Math.min(100, Math.max(1, Math.round(qual / FREE_SHIPPING_THRESHOLD * 100)));
    var shipReached = remainingShip <= 0 && qual > 0;

    if (fill) {
      fill.style.width = pct + '%';
      if (shipReached) fill.classList.add('tss-shipping-progress__fill--full');
      else fill.classList.remove('tss-shipping-progress__fill--full');
    }
    if (truckIcon) truckIcon.classList.toggle('tss-shipping-icon--reached', shipReached);

    if (msg) {
      if (shipReached) {
        msg.innerHTML = '🎉 You\'ve earned <strong>FREE</strong> shipping!';
        if (!_confettiFired) {
          _confettiFired = true;
          window.tssLaunchConfetti($('#tss-confetti-container'));
        }
      } else {
        _confettiFired = false;
        msg.innerHTML = '<strong>$' + (remainingShip / 100).toFixed(2) + '</strong> from FREE shipping';
      }
    }
  }

  /* ──────────────────────────────────────────────
     Hide priority handling line from visible list
  ────────────────────────────────────────────── */

  function hidePriorityRow() {
    $all('.cart-item').forEach(function (row) {
      var vId = row.querySelector('[data-quantity-variant-id]');
      if (vId && parseInt(vId.getAttribute('data-quantity-variant-id'), 10) === PRIORITY_VARIANT_ID) {
        row.classList.add('tss-cart-item--hidden');
        row.setAttribute('data-tss-priority-row', 'true');
      }
    });
  }

  /* Show/hide the pill based on whether the cart has visible items */
  function updatePriorityBanner(cart) {
    var row = $('#tss-priority-row');
    if (!row) return;
    row.style.display = realLineCount(cart) > 0 ? '' : 'none';
  }

  /* ──────────────────────────────────────────────
     Upsells — TSS in-theme engine (was Rebuy)
  ────────────────────────────────────────────── */

  /* Signature of the rule blobs currently in the drawer DOM (#tss-cart-rules — one per
     non-priority cart product, re-rendered by every drawer swap). This is exactly what
     TSSRecs.getForCart() reads, so the upsell list is rebuilt only once the freshly
     rendered blobs are in place (reading /cart.js alone races the DOM swap). */
  function cartUpsellSig() {
    var ids = [];
    $all('#tss-cart-rules script[id^="tss-cart-rule-"]').forEach(function (n) { ids.push(n.id); });
    return ids.sort().join(',');
  }

  function centsToDollars(c) {
    var n = (window.TSSRecs && window.TSSRecs.priceToCents) ? window.TSSRecs.priceToCents(c) : (parseInt(c, 10) || 0);
    return (n / 100).toFixed(2);
  }

  /* Engine product (cents, featured_image string) -> the Rebuy-shaped object
     ({ image: { src }, variants: [{ price: "12.34" }] }) the renderer + variant popup expect.
     Prices come from Liquid (rule products, buyer-context B2B prices) or the storefront
     endpoints the engine falls back to. */
  function toDrawerProduct(p) {
    if (!p || !p.id) return null;
    var variants = (p.variants || []).filter(function (v) { return v && v.id && v.available !== false; });
    if (!variants.length && p.variantId) {
      variants = [{ id: p.variantId, title: p.variantTitle || '', price: p.price, compare_at_price: p.compareAtPrice }];
    }
    if (!variants.length) return null;
    return {
      id: p.id,
      handle: p.handle || '',
      title: p.title || '',
      image: p.featured_image ? { src: p.featured_image } : null,
      variants: variants.map(function (v, i) {
        var cmp = v.compare_at_price != null ? v.compare_at_price : (i === 0 ? p.compareAtPrice : null);
        /* Pro B2B retail per unit (Liquid tss-retail-cents via the engine); 0/absent = none */
        var rc = parseInt(v.retail_cents, 10) || 0;
        if (!rc && p.retailCents && (String(v.id) === String(p.variantId) || (i === 0 && !p.variantId))) rc = parseInt(p.retailCents, 10) || 0;
        return {
          id: v.id,
          title: v.title || '',
          price: centsToDollars(v.price != null ? v.price : p.price),
          compare_at_price: cmp ? centsToDollars(cmp) : null,
          retail: rc ? (rc / 100).toFixed(2) : null
        };
      })
    };
  }

  /* First matched rule name across the cart, for BizSync upsell attribution. */
  function cartRuleName() {
    var nodes = document.querySelectorAll('#tss-cart-rules script[id^="tss-cart-rule-"]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var d = JSON.parse(nodes[i].textContent || '{}');
        if (d && d.ruleName) return String(d.ruleName).replace(/\|/g, '/');
      } catch (e) {}
    }
    return '';
  }

  /* B2B: cards that came from Shopify's recommendations API carry no retail and no
     buyer-context price. Read both from Liquid (sections/tss-upsell-retail) per product,
     in parallel, cached for the session. Rule / pool cards already have them. Guests and
     non-B2B: untouched. */
  var RETAIL_TTL_MS = 10 * 60 * 1000;
  function fetchRetail(handle) {
    var key = 'tss:uret:' + handle;
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < RETAIL_TTL_MS) return Promise.resolve(c.d);
    } catch (e) {}
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=tss-upsell-retail', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('retail ' + r.status); return r.text(); })
      .then(function (html) {
        var node = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-tss-upsell-retail]');
        var d = node ? JSON.parse(node.textContent || 'null') : null;
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        return d;
      })
      .catch(function () { return null; });
  }

  function enrichRetail(products) {
    products = products || [];
    if (!(window.tssVisitor && window.tssVisitor.b2b)) return Promise.resolve(products);
    return Promise.all(products.map(function (p) {
      if (!p || !p.handle) return p;
      /* Liquid already priced it: pool cards (liquidPriced) and rule cards (carry variantLocked) */
      if (p.liquidPriced === true || p.variantLocked !== undefined) return p;
      return fetchRetail(p.handle).then(function (d) {
        if (!d || !d.variants) return p;
        var byId = {};
        d.variants.forEach(function (v) { byId[String(v.id)] = v; });
        (p.variants || []).forEach(function (v) {
          var lv = byId[String(v.id)];
          if (!lv) return;
          v.price = lv.price;
          v.retail_cents = lv.retail_cents || 0;
        });
        var top = byId[String(p.variantId)] || d.variants[0];
        if (top) { p.price = top.price; p.retailCents = top.retail_cents || 0; }
        p.liquidPriced = true;
        return p;
      });
    }));
  }

  function loadUpsells() {
    if (!window.TSSRecs || typeof window.TSSRecs.getForCart !== 'function') {
      /* tss-recommendations.js is deferred — wait for it (one poller, max ~10s). */
      if (_upsellWaiting) return;
      _upsellWaiting = true;
      (function poll() {
        if (window.TSSRecs && typeof window.TSSRecs.getForCart === 'function') { _upsellWaiting = false; loadUpsells(); return; }
        if (_upsellWaitTries++ < 100) setTimeout(poll, 100);
        else _upsellWaiting = false;
      })();
      return;
    }
    if (upsellLoadInFlight) { _upsellReloadQueued = true; return; }
    upsellLoadInFlight = true;
    (_currentCart ? Promise.resolve(_currentCart) : fetchCart())
      .then(function (cart) {
        var sig = cartUpsellSig();
        var items = ((cart && cart.items) || []).filter(function (it) {
          return (it.variant_id || it.id) !== PRIORITY_VARIANT_ID && it.product_id !== PRIORITY_PRODUCT_ID;
        });
        return window.TSSRecs.getForCart(items, UPSELL_SLOTS).then(enrichRetail).then(function (products) {
          return { sig: sig, products: products || [] };
        });
      })
      .then(function (res) {
        upsellLoadInFlight = false;
        cachedRebuyProducts = res.products.map(toDrawerProduct).filter(Boolean);
        _upsellSig = res.sig;
        /* Cart changed while we were building (e.g. an add landed) → rebuild. */
        if (_upsellReloadQueued || cartUpsellSig() !== res.sig) {
          _upsellReloadQueued = false;
          loadUpsells(); /* sets in-flight first so the render below doesn't double-trigger */
          if (cachedRebuyProducts.length) renderUpsells();
          return;
        }
        if (cachedRebuyProducts.length) renderUpsells();
        else {
          var section = $('#tss-upsell-section');
          if (section) section.style.display = 'none';
        }
      })
      .catch(function (err) { upsellLoadInFlight = false; console.warn('TSS upsell error:', err); });
  }

  var _upsellAnimUntil = 0;
  function renderUpsells() {
    var scroll = $('#tss-upsell-products');
    var section = $('#tss-upsell-section');
    if (!scroll) return;

    /* If a card is currently animating out, defer the re-render so we don't
       wipe the in-progress fade. */
    if (Date.now() < _upsellAnimUntil) {
      setTimeout(renderUpsells, _upsellAnimUntil - Date.now() + 50);
      return;
    }

    /* Cart contents changed since the list was built → rebuild from the
       freshly rendered rule blobs. Keep showing the current cards meanwhile. */
    if (_upsellSig !== null && cartUpsellSig() !== _upsellSig && !upsellLoadInFlight && !_upsellWaiting) {
      loadUpsells();
      if (!cachedRebuyProducts.length) return;
    }

    /* If the engine hasn't resolved yet, don't clear existing cards —
       just kick off a fetch and bail. Prevents a race where we wipe
       the scroll to empty during a transient empty state. */
    if (!cachedRebuyProducts.length) {
      if (_upsellSig === null && !upsellLoadInFlight && !_upsellWaiting) loadUpsells();
      return;
    }

    /* Cart product handles (skip anything already in cart, plus the priority product) */
    var cartHandles = {};
    if (_currentCart && _currentCart.items) {
      _currentCart.items.forEach(function (it) { if (it.handle) cartHandles[it.handle] = true; });
    }
    upsellProductMap = {};
    var html = '';
    var cardCount = 0;
    cachedRebuyProducts.forEach(function (product) {
      var handle = product.handle || '';
      if (handle && cartHandles[handle]) return;
      if (product.id === PRIORITY_PRODUCT_ID || parseInt(product.id, 10) === PRIORITY_PRODUCT_ID) return;
      if (!product.variants || !product.variants.length) return;

      upsellProductMap[product.id] = product;
      var variant = product.variants[0];
      var hasMultiple = product.variants.length > 1;
      var imgSrc = product.image ? product.image.src : (product.images && product.images[0] ? product.images[0].src : '');
      if (imgSrc) imgSrc = imgSrc.replace(/\.([^.]+)(\?|$)/, '_200x200.$1$2');
      var vPrice = parseFloat(variant.price) || 0;
      var vCompare = parseFloat(variant.compare_at_price) || 0;

      var vRetail = parseFloat(variant.retail) || 0;

      var fromLabel = hasMultiple ? '<span class="tss-upsell-card__from">From</span> ' : '';
      var comparePrice = (vCompare > vPrice)
        ? '<span class="tss-upsell-card__compare">$' + vCompare.toFixed(2) + '</span> '
        : '';
      var price = '<span class="tss-upsell-card__sale">$' + vPrice.toFixed(2) + '</span>';
      /* B2B: their price, retail struck through, Save $X (same as product cards) */
      if (vRetail > vPrice) {
        comparePrice = '';
        price += ' <s class="tss-upsell-card__retail"><span class="visually-hidden">Retail price </span>$' + vRetail.toFixed(2) + '</s>' +
          '<span class="tss-upsell-card__save">Save $' + (vRetail - vPrice).toFixed(2) + '</span>';
      }
      var addAttr = hasMultiple
        ? 'data-upsell-options="' + product.id + '"'
        : 'data-upsell-add="' + variant.id + '"';

      var safeTitle = (product.title || '').replace(/"/g, '&quot;');
      html += '<div class="tss-upsell-card">' +
        '<div class="tss-upsell-card__img">' +
          '<img src="' + imgSrc + '" alt="' + safeTitle + '" loading="lazy">' +
          '<button type="button" class="tss-upsell-card__add" ' + addAttr + ' aria-label="Add">+</button>' +
        '</div>' +
        '<div class="tss-upsell-card__name">' + safeTitle + '</div>' +
        '<div class="tss-upsell-card__prices">' + fromLabel + comparePrice + price + '</div>' +
      '</div>';
      cardCount++;
    });

    /* Hide the section entirely if no cards to show; otherwise render. */
    if (cardCount === 0) {
      if (section) section.style.display = 'none';
      return;
    }
    if (section) section.style.display = '';
    scroll.innerHTML = html;
    scroll.scrollLeft = 0;
  }

  /* ──────────────────────────────────────────────
     Drawer section refresh — triggers Dawn's re-render
  ────────────────────────────────────────────── */

  function refreshDrawerSection() {
    return fetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var srcInner = parsed.querySelector('#CartDrawer .drawer__inner');
        var dstInner = document.querySelector('#CartDrawer .drawer__inner');
        if (srcInner && dstInner) {
          dstInner.innerHTML = srcInner.innerHTML;
        }
        /* Also refresh the cart bubble */
        fetch('/?section_id=cart-icon-bubble', { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html2) {
            var p2 = new DOMParser().parseFromString(html2, 'text/html');
            var s2 = p2.querySelector('.shopify-section');
            var t2 = document.getElementById('cart-icon-bubble');
            if (t2 && s2) t2.innerHTML = s2.innerHTML;
          }).catch(function(){});
      })
      .then(postRenderTasks)
      .catch(function(){});
  }

  /* ──────────────────────────────────────────────
     Post-render tasks (runs after every re-render)
  ────────────────────────────────────────────── */

  function postRenderTasks() {
    return fetchCart().then(function (cart) {
      hidePriorityRow();
      updatePriorityBanner(cart);
      updateShippingBar(cart);
      renderUpsells();
      bindDiscountToggle();
      /* Toggle is-empty class — Dawn relies on it for the empty state */
      var drawer = getDrawer();
      if (drawer) {
        var visible = realLineCount(cart);
        if (visible === 0) drawer.classList.add('is-empty');
        else drawer.classList.remove('is-empty');
      }
      return cart;
    });
  }

  /* ──────────────────────────────────────────────
     Discount toggle + apply
  ────────────────────────────────────────────── */

  function bindDiscountToggle() {
    var toggle = $('#tss-discount-toggle');
    var body = $('#tss-discount-body');
    if (toggle && body && !toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', function () {
        toggle.classList.toggle('open');
        body.classList.toggle('open');
      });
    }
    var apply = $('#tss-discount-apply');
    if (apply && !apply.dataset.bound) {
      apply.dataset.bound = '1';
      apply.addEventListener('click', applyDiscount);
    }
    var input = $('#tss-discount-input');
    if (input && !input.dataset.bound) {
      input.dataset.bound = '1';
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); } });
    }
  }

  function applyDiscount() {
    var input = $('#tss-discount-input');
    var btn = $('#tss-discount-apply');
    var msg = $('#tss-discount-msg');
    if (!input || !btn) return;
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    btn.textContent = '...'; btn.disabled = true;
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'follow', credentials: 'same-origin' })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        var applied = false;
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
          cart.cart_level_discount_applications.forEach(function (d) {
            if (d.title && d.title.toLowerCase() === code.toLowerCase()) applied = true;
          });
        }
        if (!applied && cart.total_discount > 0) applied = true;
        if (applied) {
          if (msg) { msg.textContent = 'Discount applied!'; msg.className = 'tss-discount-msg tss-discount-msg--success'; }
          setTimeout(function () { window.location.reload(); }, 500);
        } else {
          if (msg) { msg.textContent = 'Invalid discount code.'; msg.className = 'tss-discount-msg tss-discount-msg--error'; }
          btn.textContent = 'Apply'; btn.disabled = false;
        }
      })
      .catch(function () {
        if (msg) { msg.textContent = 'Could not apply code. Try at checkout.'; msg.className = 'tss-discount-msg tss-discount-msg--error'; }
        btn.textContent = 'Apply'; btn.disabled = false;
      });
  }

  /* ──────────────────────────────────────────────
     Confetti
  ────────────────────────────────────────────── */
  var _confettiBusy = false;
  window.tssLaunchConfetti = function (container) {
    if (!container || _confettiBusy) return;
    _confettiBusy = true;
    container.innerHTML = '';
    var colors = ['#1cbbb9', '#13a7a5', '#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff', '#ff922b', '#cc5de8'];
    var COUNT = 24; /* down from 40 — same visual punch, ~40% less work */
    var frag = document.createDocumentFragment();
    for (var i = 0; i < COUNT; i++) {
      var piece = document.createElement('span');
      piece.className = 'tss-confetti-piece';
      var cx = (Math.random() - 0.5) * 300;
      var cy = (Math.random() - 1) * 200 - 20;
      piece.style.cssText =
        'background:' + colors[Math.floor(Math.random() * colors.length)] +
        ';left:' + (Math.random() * 100) + '%;top:50%' +
        ';--cx:' + cx + 'px;--cy:' + cy + 'px' +
        ';animation-delay:' + (Math.random() * 0.3) + 's';
      frag.appendChild(piece);
    }
    container.appendChild(frag); /* one reflow instead of 24 */
    setTimeout(function () {
      container.innerHTML = '';
      _confettiBusy = false;
    }, 1600);
  };

  /* ──────────────────────────────────────────────
     Event wiring
  ────────────────────────────────────────────── */

  function wireEvents() {
    drawerEl = getDrawer();
    if (!drawerEl) return;

    /* Checkout submit — always guarantee priority handling is in cart. */
    drawerEl.addEventListener('submit', function (e) {
      var form = e.target.closest('#CartDrawer-Form');
      if (!form) return;
      /* Nothing real to buy (only add-ons) → no checkout */
      if (_currentCart && realLineCount(_currentCart) === 0) {
        e.preventDefault();
        stripOrphanAddons(_currentCart);
        return;
      }
      if (_currentCart && cartHasPriority(_currentCart)) return;
      e.preventDefault();
      var btn = $('#CartDrawer-Checkout');
      if (btn) btn.disabled = true;
      ensurePriorityInCart().then(function () {
        if (btn) btn.disabled = false;
        form.submit();
      });
    });

    /* Add a brief shimmer/highlight on the cart row when its qty button is
       pressed or its remove button is clicked — gives instant visual feedback
       while Dawn fetches /cart/change in the background. */
    drawerEl.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.quantity__button, .cart-remove-button, cart-remove-button button');
      if (qtyBtn) {
        var row = qtyBtn.closest('tr.cart-item');
        if (row) {
          row.classList.add('tss-updating');
          /* Removed by the next Dawn swap automatically (innerHTML replace
             discards the class). Safety timeout in case swap doesn't happen. */
          setTimeout(function () { row.classList.remove('tss-updating'); }, 1200);
        }
      }
    }, true); /* capture phase so we run before Dawn's handler */

    drawerEl.addEventListener('click', function (e) {
      /* Collapsible "Details" toggle for custom properties */
      var propsToggle = e.target.closest('.tss-props-toggle');
      if (propsToggle) {
        e.preventDefault();
        var body = propsToggle.nextElementSibling;
        var open = propsToggle.getAttribute('aria-expanded') === 'true';
        propsToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (body) {
          if (open) body.setAttribute('hidden', '');
          else body.removeAttribute('hidden');
        }
        return;
      }
      /* Upsell single-variant add */
      var addBtn = e.target.closest('[data-upsell-add]');
      var optionsBtn = e.target.closest('[data-upsell-options]');
      var imgArea = e.target.closest('.tss-upsell-card__img');
      if (imgArea && !addBtn && !optionsBtn) {
        var inner = imgArea.querySelector('[data-upsell-add], [data-upsell-options]');
        if (inner) {
          if (inner.dataset.upsellOptions) optionsBtn = inner;
          else addBtn = inner;
        }
      }
      if (addBtn && !optionsBtn) {
        var vid = parseInt(addBtn.dataset.upsellAdd, 10);
        var card = addBtn.closest('.tss-upsell-card');
        addBtn.innerHTML = '✓';
        addBtn.style.background = '#28a745';
        /* Tell renderUpsells to wait until our fade-out finishes (~700ms) */
        _upsellAnimUntil = Date.now() + 700;
        /* Fade & shrink the card out, then physically remove it so the next
           card slides into its place. We do this BEFORE the fetch resolves
           so the interaction feels instant. */
        if (card) {
          var width = card.offsetWidth;
          card.style.transition = 'opacity .25s ease, transform .25s ease, max-width .35s ease .15s, margin-right .35s ease .15s, padding .35s ease .15s';
          card.style.maxWidth = width + 'px';
          card.style.flexBasis = width + 'px';
          requestAnimationFrame(function () {
            card.style.opacity = '0';
            card.style.transform = 'scale(0.85)';
            setTimeout(function () {
              card.style.maxWidth = '0px';
              card.style.flexBasis = '0px';
              card.style.marginRight = '-12px'; /* collapse the gap */
              card.style.padding = '0';
              card.style.overflow = 'hidden';
            }, 150);
            setTimeout(function () { if (card.parentNode) card.remove(); }, 600);
          });
        }
        /* Drop from cache so renderUpsells (when it eventually runs) won't put it back */
        cachedRebuyProducts = cachedRebuyProducts.filter(function (p) {
          return !(p.variants || []).some(function (v) { return parseInt(v.id, 10) === vid; });
        });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: {
            /* BizSync upsell attribution — same compact form as TSS retail */
            '_tss_u': 'cart_drawer|tss-cart-drawer-upsell|' + cartRuleName() + '||'
          } }] })
        }).catch(function () {
          /* Restore the card on error */
          if (card && card.parentNode) {
            card.style.transition = '';
            card.style.opacity = '1';
            card.style.transform = '';
            card.style.maxWidth = '';
            card.style.flexBasis = '90px';
            card.style.marginRight = '';
            card.style.padding = '';
          }
          addBtn.innerHTML = '+';
          addBtn.style.background = '';
        });
        return;
      }
      if (optionsBtn) {
        var pid = optionsBtn.dataset.upsellOptions;
        var product = upsellProductMap[pid] || upsellProductMap[parseInt(pid, 10)];
        if (product) showVariantPopup(product);
        return;
      }
    });
  }

  /* Variant popup */
  var _popupProductId = null;
  function showVariantPopup(product) {
    if (!product) { console.warn('[cart-drawer] showVariantPopup called with no product'); return; }
    var overlay = document.getElementById('tss-variant-popup-overlay');
    if (!overlay) { console.warn('[cart-drawer] popup overlay not in DOM'); return; }
    /* Re-append to <body> every time so it's always on top of any stacking context */
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    var titleEl = overlay.querySelector('#tss-variant-popup-title');
    var imgEl = overlay.querySelector('#tss-variant-popup-img');
    var optionsEl = overlay.querySelector('#tss-variant-popup-options');
    var atcBtn = overlay.querySelector('#tss-variant-popup-atc');
    if (!optionsEl) { console.warn('[cart-drawer] popup options container missing'); return; }
    if (!product.variants || !product.variants.length) {
      console.warn('[cart-drawer] product has no variants', product);
      return;
    }
    _popupProductId = product.id;
    titleEl.textContent = product.title;
    /* Clear previous image so the old one doesn't flash */
    imgEl.removeAttribute('src');
    imgEl.style.visibility = 'hidden';
    var imgSrc = product.image ? product.image.src : (product.images && product.images[0] ? product.images[0].src : '');
    if (imgSrc) {
      var finalSrc = imgSrc.replace(/\.([^.]+)(\?|$)/, '_300x300.$1$2');
      /* Preload — show overlay only after image is ready so there's no flash */
      var preload = new Image();
      preload.onload = function () {
        imgEl.src = finalSrc;
        imgEl.alt = product.title;
        imgEl.style.display = '';
        imgEl.style.visibility = '';
      };
      preload.onerror = function () {
        imgEl.src = finalSrc;
        imgEl.style.visibility = '';
      };
      preload.src = finalSrc;
    } else { imgEl.style.display = 'none'; }

    optionsEl.innerHTML = product.variants.map(function (v) {
      var vp = parseFloat(v.price) || 0;
      var vc = parseFloat(v.compare_at_price) || 0;
      var vr = parseFloat(v.retail) || 0;
      var priceHTML = (vc > vp)
        ? '<span style="text-decoration:line-through;color:#999;margin-right:4px">$' + vc.toFixed(2) + '</span><strong>$' + vp.toFixed(2) + '</strong>'
        : '<strong>$' + vp.toFixed(2) + '</strong>';
      /* B2B: their price, retail struck through, Save $X */
      if (vr > vp) {
        priceHTML = '<strong>$' + vp.toFixed(2) + '</strong> ' +
          '<s class="tss-upsell-card__retail"><span class="visually-hidden">Retail price </span>$' + vr.toFixed(2) + '</s> ' +
          '<span class="tss-upsell-card__save">Save $' + (vr - vp).toFixed(2) + '</span>';
      }
      return '<div class="tss-variant-popup__option" data-variant-id="' + v.id + '" data-variant-price="' + vp + '">' +
        '<div class="tss-variant-popup__option-info">' +
          '<span class="tss-variant-popup__option-name">' + (v.title || '') + '</span>' +
          '<div class="tss-variant-popup__option-price">' + priceHTML + '</div>' +
        '</div>' +
        '<div class="tss-variant-popup__qty">' +
          '<button type="button" data-vqty="-1">−</button>' +
          '<span data-vqty-val>0</span>' +
          '<button type="button" data-vqty="1">+</button>' +
        '</div>' +
      '</div>';
    }).join('');

    atcBtn.disabled = true;
    atcBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> Add to Cart';
    overlay.classList.add('active');
    overlay.onclick = function (e) { if (e.target === overlay) overlay.classList.remove('active'); };
  }

  document.addEventListener('click', function (e) {
    var qBtn = e.target.closest('[data-vqty]');
    if (qBtn) {
      var opt = qBtn.closest('.tss-variant-popup__option');
      var valSpan = opt.querySelector('[data-vqty-val]');
      var cur = parseInt(valSpan.textContent, 10) || 0;
      var delta = parseInt(qBtn.dataset.vqty, 10);
      var newVal = Math.max(0, cur + delta);
      valSpan.textContent = newVal;
      opt.classList.toggle('has-qty', newVal > 0);
      updatePopupAtcButton();
      return;
    }
    var atcBtn = e.target.closest('#tss-variant-popup-atc');
    if (atcBtn && !atcBtn.disabled) {
      var overlay = $('#tss-variant-popup-overlay');
      var items = [];
      $all('#tss-variant-popup-options .tss-variant-popup__option').forEach(function (o) {
        var q = parseInt(o.querySelector('[data-vqty-val]').textContent, 10) || 0;
        if (q > 0) items.push({ id: parseInt(o.dataset.variantId, 10), quantity: q, properties: {
          '_tss_u': 'cart_drawer|tss-cart-drawer-variant-popup|' + cartRuleName() + '||'
        } });
      });
      if (!items.length) return;
      atcBtn.disabled = true;
      atcBtn.innerHTML = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function () {
        atcBtn.innerHTML = '✓ Added!';
        atcBtn.style.background = '#28a745';
        setTimeout(function () {
          if (overlay) overlay.classList.remove('active');
          atcBtn.style.background = '';
          /* Fetch interceptor's syncDrawerFromCart handles refresh */
        }, 500);
      })
      .catch(function () { atcBtn.disabled = false; atcBtn.innerHTML = 'Add to Cart'; });
    }
  });

  function updatePopupAtcButton() {
    var atcBtn = $('#tss-variant-popup-atc');
    if (!atcBtn) return;
    var total = 0, count = 0;
    $all('#tss-variant-popup-options .tss-variant-popup__option').forEach(function (o) {
      var q = parseInt(o.querySelector('[data-vqty-val]').textContent, 10) || 0;
      var p = parseFloat(o.dataset.variantPrice) || 0;
      count += q; total += q * p;
    });
    if (count > 0) {
      atcBtn.disabled = false;
      atcBtn.innerHTML = 'Add ' + count + ' item' + (count > 1 ? 's' : '') + ' — $' + total.toFixed(2);
    } else {
      atcBtn.disabled = true;
      atcBtn.innerHTML = 'Add to Cart';
    }
  }

  /* ──────────────────────────────────────────────
     Mutation observer — re-apply after Dawn re-renders
  ────────────────────────────────────────────── */

  var _obs = null;
  var _obsTarget = null;
  function setupObserver() {
    var target = document.getElementById('CartDrawer');
    if (!target) return;
    _obsTarget = target;
    var debounce = null;
    _obs = new MutationObserver(function (mutations) {
      /* Ignore mutations that happened only inside the upsell scroll container —
         those are caused by our own renderUpsells() and would create a loop. */
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t && !(t.closest && t.closest('#tss-upsell-products'))) {
          relevant = true;
          break;
        }
      }
      if (!relevant) return;
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        _obs.disconnect();
        fetchCart().then(function (cart) {
          hidePriorityRow();
          updatePriorityBanner(cart);
          updateShippingBar(cart);
          renderUpsells();
          bindDiscountToggle();
          var drawer = getDrawer();
          if (drawer) {
            var visible = realLineCount(cart);
            if (visible === 0) drawer.classList.add('is-empty');
            else drawer.classList.remove('is-empty');
          }
        }).then(function () {
          /* Reconnect after our own DOM changes settle */
          if (_obsTarget && _obs) _obs.observe(_obsTarget, { childList: true, subtree: true });
        });
      }, 60);
    });
    _obs.observe(target, { childList: true, subtree: true });
  }

  /* ──────────────────────────────────────────────
     Auto-open drawer on /cart page
  ────────────────────────────────────────────── */

  function maybeAutoOpenOnCartPage() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path !== '/cart' && !document.body.classList.contains('template-cart')) return;
    var drawer = getDrawer();
    if (!drawer) return;
    /* Wait until cart-drawer custom element has its open() method wired */
    var tries = 0;
    var tick = setInterval(function () {
      tries++;
      if (typeof drawer.open === 'function') {
        clearInterval(tick);
        drawer.open();
      } else if (tries > 50) {
        clearInterval(tick);
      }
    }, 40);
  }

  /* ──────────────────────────────────────────────
     Boot
  ────────────────────────────────────────────── */

  function boot() {
    drawerEl = getDrawer();
    /* Move variant popup overlay to <body> so position:fixed escapes Dawn's
       transform stacking context (which was confining it to the drawer width). */
    var popup = document.getElementById('tss-variant-popup-overlay');
    if (popup && popup.parentNode !== document.body) {
      document.body.appendChild(popup);
    }
    /* Same for confetti container */
    var confetti = document.getElementById('tss-confetti-container');
    if (confetti && confetti.parentNode !== document.body) {
      document.body.appendChild(confetti);
    }
    /* CRITICAL: narrow Dawn's CartDrawerItems swap target from the entire
       .drawer__inner down to just .js-contents (the cart-items table area).
       Without this, every qty/remove wipes our shipping bar, pill, upsells,
       and footer, then we have to restore them — which causes visible flicker.
       With this, Dawn only swaps the cart items list; everything else stays
       put untouched. */
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer-items').then(function () {
        var proto = customElements.get('cart-drawer-items') &&
                    customElements.get('cart-drawer-items').prototype;
        if (proto && !proto.__tssPatched) {
          proto.__tssPatched = true;
          proto.getSectionsToRender = function () {
            return [
              { id: 'CartDrawer-CartItems', section: 'cart-drawer', selector: '#CartDrawer-CartItems' },
              { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
            ];
          };
        }
      });
    }
    wireEvents();
    /* Cart page (and any other form posting a checkout to /cart): no checkout when the
       cart holds only service add-ons. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id === 'CartDrawer-Form') return;
      var action = form.getAttribute && (form.getAttribute('action') || '');
      if (!/\/cart\/?$/.test(action) && form.id !== 'cart') return;
      var sub = e.submitter;
      if (!sub || sub.name !== 'checkout') return;
      if (_currentCart && realLineCount(_currentCart) === 0) {
        e.preventDefault();
        stripOrphanAddons(_currentCart).then(function () { window.location.reload(); });
      }
    }, true);
    /* No MutationObserver — fetch/XHR interceptors are the single source of
       sync now. The observer was racing with our own renders and causing
       flicker/lag (each renderUpsells mutation re-fired the observer which
       re-rendered which mutated which re-fired...). */
    bindDiscountToggle();
    /* Ensure priority handling is in cart for every visitor */
    fetchCart().then(function (cart) {
      if (cart && cart.item_count > 0 && realLineCount(cart) === 0) {
        stripOrphanAddons(cart);
        return;
      }
      var needsPriority = cart && realLineCount(cart) > 0 && !cartHasPriority(cart);
      var needsGiftRemove = cartHasFreeGift(cart);
      if (needsPriority || needsGiftRemove) {
        var p = Promise.resolve();
        if (needsPriority) p = p.then(ensurePriorityInCart);
        p.then(fetchCart).then(reconcileFreeGift).then(function () {
          syncDrawerFromCart();
        });
      } else {
        hidePriorityRow();
        updatePriorityBanner(cart);
        updateShippingBar(cart);
        updateFooterTotals(cart);
      }
      renderUpsells();
    });
    loadUpsells();
    maybeAutoOpenOnCartPage();

    /* After ANY cart-mutating fetch, refresh shipping bar, pill, upsells, and
       (for adds) ensure priority handling is present. This covers apps / flows
       that don't trigger Dawn's section re-render. */
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var body = init && init.body;
      var bodyStr = '';
      try { bodyStr = (typeof body === 'string') ? body : (body ? JSON.stringify(body) : ''); } catch(e){}
      var isPriorityAdd = bodyStr.indexOf(String(PRIORITY_VARIANT_ID)) > -1 &&
                          bodyStr.indexOf('_priority_handling') > -1;
      var isInternalAdd = isPriorityAdd;
      var isAdd = url.indexOf('/cart/add') > -1 && !isInternalAdd;
      var isChange = url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1;
      var isClear = url.indexOf('/cart/clear') > -1;
      var result = origFetch.apply(this, arguments);
      if (isAdd) {
        var dawnRenders = addRequestRendersSections(body);
        result.then(function (resp) {
          if (!resp || resp.status < 200 || resp.status >= 300) return;
          afterCartAdd(dawnRenders);
        }).catch(function () {});
      } else if (isChange || isClear) {
        /* A full drawer sync that started BEFORE this change (e.g. right after the Priority Handling
           auto-add) would paint pre-change quantities when it lands; queue one more sync so the
           drawer settles on the real cart. */
        if (_syncInFlight) _syncQueued = true;
        /* Dawn handles cart-items swap on qty/remove. We refresh bar + pill,
           and strip the legacy free gift if it's still lingering in the cart. */
        result.then(function (resp) {
          if (!resp || resp.status < 200 || resp.status >= 300) return;
          quickBarUpdate();
          fetchCart().then(reconcileFreeGift).then(stripOrphanAddons).then(function (c) {
            if (c) { updateShippingBar(c); updateFooterTotals(c); }
          });
        }).catch(function () {});
      }
      return result;
    };

    /* Also catch XHR-based add-to-cart (jQuery, legacy apps) */
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__tssUrl = url || '';
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        var u = xhr.__tssUrl || '';
        if (u.indexOf('/cart/add') > -1) {
          xhr.addEventListener('loadend', function () {
            if (xhr.status < 200 || xhr.status >= 300) return;
            afterCartAdd(false);
          });
        } else if (u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1) {
          xhr.addEventListener('loadend', function () {
            if (xhr.status < 200 || xhr.status >= 300) return;
            quickBarUpdate();
            fetchCart().then(reconcileFreeGift).then(stripOrphanAddons).then(function (c) {
              if (c) { updateShippingBar(c); updateFooterTotals(c); }
            });
          });
        }
        return origSend.apply(this, arguments);
      };
    }

    /* No form-submit interceptor — it was catching "Choose options" buttons
       on product cards (which submit the wrapping product-form even though
       no variant is selected). Native form posts to /cart/add will navigate
       to /cart, which auto-opens the drawer via maybeAutoOpenOnCartPage(). */
  }

  /* Dawn's product form sends `sections` with its add and swaps the drawer itself. */
  function addRequestRendersSections(body) {
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('sections');
      if (typeof body === 'string') return body.indexOf('"sections"') > -1 || /(^|&)sections=/.test(body);
    } catch (e) {}
    return false;
  }

  /* After an add (2026-10-28): every add used to re-read the cart three times and then
     rebuild the whole drawer, on top of Dawn's own rebuild. That doubled the wait and reset
     the drawer while it was being scrolled. Now the drawer is rebuilt only when Dawn didn't
     render it or the priority line was just added; otherwise only the totals, bar and
     upsells are patched from the cart we already fetched. */
  function afterCartAdd(dawnRenders) {
    _priorityJustAdded = false;
    return ensurePriorityInCart()
      .then(function (cart) { return cart || fetchCart(); })
      .then(function (cart) { return cartHasFreeGift(cart) ? removeFreeGiftFromCart() : cart; })
      .then(function (cart) {
        if (!dawnRenders || _priorityJustAdded || !cart) return syncDrawerFromCart();
        _currentCart = cart;
        hidePriorityRow();
        updatePriorityBanner(cart);
        updateShippingBar(cart);
        updateFooterTotals(cart);
        if (cartUpsellSig() !== _upsellSig) renderUpsells();
        return cart;
      })
      .then(function () { autoOpenDrawer(); })
      .catch(function () {});
  }

  /* Open the cart drawer if it isn't already visible */
  function autoOpenDrawer() {
    if (isTSSApp()) {
      notifyTSSAppCartAdded();
      return;
    }
    var d = getDrawer();
    if (!d) return;
    if (d.classList.contains('active')) return; /* already open */
    if (typeof d.open === 'function') {
      try { d.open(); } catch (e) { console.warn('[cart-drawer] open() threw', e); }
    } else {
      d.classList.add('active', 'animate');
      d.style.visibility = 'visible';
      document.body.classList.add('overflow-hidden');
    }
  }

  /* ONE atomic sync per user action. No splits, no parallel paths.
     Strategy: fetch sections + cart in parallel, then do a single
     innerHTML swap of #CartDrawer .drawer__inner. JS updates shipping
     bar AFTER the swap so the bar's CSS transition animates from the
     new server-rendered width — no double-update flicker. */
  var _syncInFlight = null;
  var _syncQueued = false;

  function syncDrawerFromCart() {
    if (_syncInFlight) { _syncQueued = true; return _syncInFlight; }
    _syncInFlight = Promise.all([
      fetch('/?section_id=cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.text(); }),
      fetch('/?section_id=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.text(); }),
      fetchCart()
    ]).then(function (results) {
      var sectionHtml = results[0];
      var bubbleHtml = results[1];
      var cart = results[2];
      _currentCart = cart;
      /* Single batched DOM update inside one rAF — no intermediate paints */
      requestAnimationFrame(function () {
        try {
          var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
          var srcInner = parsed.querySelector('#CartDrawer .drawer__inner');
          var dstInner = document.querySelector('#CartDrawer .drawer__inner');
          if (srcInner && dstInner) dstInner.innerHTML = srcInner.innerHTML;
        } catch (e) {}
        try {
          var p2 = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          var s2 = p2.querySelector('.shopify-section');
          var t2 = document.getElementById('cart-icon-bubble');
          if (t2 && s2) t2.innerHTML = s2.innerHTML;
        } catch (e) {}
        hidePriorityRow();
        updatePriorityBanner(cart);
        renderUpsells();
        bindDiscountToggle();
        var d = getDrawer();
        if (d) {
          var visible = realLineCount(cart);
          if (visible === 0) d.classList.add('is-empty');
          else d.classList.remove('is-empty');
        }
        /* Bar update after the swap so the transition runs from the
           new server-rendered baseline to the precise JS-calculated value. */
        updateShippingBar(cart);
      });
      return cart;
    }).then(function (cart) {
      _syncInFlight = null;
      if (_syncQueued) { _syncQueued = false; syncDrawerFromCart(); }
      return cart;
    }).catch(function (e) {
      console.warn('[cart-drawer] sync error', e);
      _syncInFlight = null;
      if (_syncQueued) { _syncQueued = false; syncDrawerFromCart(); }
    });
    return _syncInFlight;
  }

  /* Lightweight update for cases where Dawn handles the cart-items swap
     (qty/remove). We update the bar IMMEDIATELY for instant feedback, then
     wait for Dawn's innerHTML swap to settle and re-populate the bits Dawn
     wipes out: upsells, priority pill state, discount toggle bindings.
     Dawn's swap targets .drawer__inner — same parent as our upsell row. */
  /* For Dawn's qty/remove flow: update bar immediately, then watch for
     Dawn's single innerHTML swap of .drawer__inner and re-apply our layer
     exactly ONCE after it completes (no double-flicker). */
  var _restoreObserver = null;
  /* For Dawn's qty/remove flow: bar + priority pill + subtotal update via
     JS only. Dawn's narrowed swap (now scoped to #CartDrawer-CartItems only)
     means our upsells, pill, and footer never get touched — no flicker,
     no restore needed. We just patch the values that live in the footer
     (which Dawn no longer re-renders). */
  function quickBarUpdate() {
    return fetchCart().then(function (cart) {
      _currentCart = cart;
      updateShippingBar(cart);
      updatePriorityBanner(cart);
      updateFooterTotals(cart);
      hidePriorityRow();
      /* Removing a product changes which upsell rules match — rebuild once
         Dawn's #CartDrawer-CartItems swap (which carries #tss-cart-rules) lands. */
      setTimeout(function () { if (cartUpsellSig() !== _upsellSig) renderUpsells(); }, 300);
      return cart;
    });
  }

  function formatMoney(cents, withCurrency) {
    var amount = (Math.abs(cents) / 100).toFixed(2);
    var sign = cents < 0 ? '-' : '';
    return sign + '$' + amount + (withCurrency ? ' USD' : '');
  }

  function updateFooterTotals(cart) {
    /* Subtotal = sum of (compare-at OR original) × qty.
       /cart.js does NOT include compare_at_price, so we read it from the
       DOM data attribute that Liquid emitted on each cart row.
       Falls back to /cart.js values for any rows we can't find. */
    var subtotal = 0;
    var byVariant = {};
    (cart.items || []).forEach(function (it) {
      if ((it.variant_id || it.id) === PRIORITY_VARIANT_ID) return;
      byVariant[it.variant_id] = it;
    });
    var seen = {};
    Array.prototype.forEach.call(
      document.querySelectorAll('#CartDrawer tr.cart-item'),
      function (row) {
        if (row.dataset.tssPriorityRow === 'true') return;
        var vid = parseInt(row.dataset.tssVariantId, 10);
        if (!vid) return;
        seen[vid] = true;
        var cmp = parseInt(row.dataset.tssCompareCents, 10) || 0;
        var qtyInput = row.querySelector('.quantity__input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : (byVariant[vid] && byVariant[vid].quantity) || 0;
        if (!cmp && byVariant[vid]) cmp = byVariant[vid].original_price;
        subtotal += cmp * qty;
      }
    );
    /* Add anything in the cart but not yet in the DOM (race during add) */
    Object.keys(byVariant).forEach(function (vid) {
      if (seen[vid]) return;
      var it = byVariant[vid];
      subtotal += it.original_price * it.quantity;
    });

    var totalSavings = subtotal - cart.total_price;
    var hasSavings = totalSavings > 0;

    var subEl = document.querySelector('#CartDrawer [data-tss-subtotal]');
    if (subEl) subEl.textContent = formatMoney(subtotal, false);

    var amtEl = document.querySelector('#CartDrawer [data-tss-discount-amount]');
    if (amtEl) amtEl.textContent = '-' + formatMoney(totalSavings > 0 ? totalSavings : 0, false);

    var discountWrap = document.querySelector('#CartDrawer [data-tss-discounts]');
    if (discountWrap) {
      if (hasSavings) discountWrap.removeAttribute('hidden');
      else discountWrap.setAttribute('hidden', '');
    }

    var totalRow = document.querySelector('#CartDrawer [data-tss-total-row]');
    var totalEl = document.querySelector('#CartDrawer [data-tss-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price, true);
    if (totalRow) {
      if (hasSavings) totalRow.removeAttribute('hidden');
      else totalRow.setAttribute('hidden', '');
    }

    var dawnTotal = document.querySelector('#CartDrawer .totals__total-value');
    if (dawnTotal) dawnTotal.textContent = formatMoney(cart.total_price, true);
  }

  /* Retail themes expose this from layout/theme.liquid + cart-drawer.custom.js.
     Pro builders call it after /cart/add.js — same TSSApp bridge as autoOpenDrawer. */
  window.ssrOpenCartDrawer = function () {
    autoOpenDrawer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
